module.exports = __webpack_public_path__ + "img/product_23.847fba8.jpg";